<template>
    <div class="bottom-space tab-component">
        <div class="tab">
            <button id="Display-button" class="tablinks" @click='showTab("Display")'>Display</button>
            <button id="Date-button" class="tablinks active" @click='showTab("Date")'>Date</button>
        </div>

        <div id="Display" class="tabcontent">
            <p>Placeholder for display type.</p>
        </div>

        <div id="Date" class="tabcontent big-border">
            <DateSelector :sources="sources" :date="date" @setSelectedDate="setSelectedDate($event)"/>
        </div>
    </div>
</template>

<script lang="ts">
import DateSelector from './DateSelector.vue'

export default {
    name: 'FilterPanel',
    components: {
        DateSelector
    },
    props: {
        sources: Array,
        date: Date.now()
    },
    data () {
        return {
            selectedViewType: "dots",
            selectedDate: null
        }
    },
    methods: {
        setSelectedDate(date) {
            this.selectedDate = date;
            this.$emit('setSelectedDate', this.selectedDate);
        },
        showTab(name) {
            console.log("Hiiiii")
            // Declare all variables
            var i, tabcontent, tablinks;

            // Get all elements with class="tabcontent" and hide them
            tabcontent = document.getElementsByClassName("tabcontent");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }

            // Get all elements with class="tablinks" and remove the class "active"
            tablinks = document.getElementsByClassName("tablinks");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" active", "");
            }

            // Show the current tab, and add an "active" class to the button that opened the tab
            document.getElementById(name).style.display = "block";
            document.getElementById(name + "-button").className += " active";
        }
    }
};
</script>

<style lang="scss" scoped>
$blue: #0079c1;
$gray: #959595;
$white: #fff;

.bottom-space {
    margin-bottom: 20px;
}

 /* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
}

/* Style the buttons that are used to open the tab content */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #ccc;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 5px 5px;
  border: 1px solid #ccc;
  border-top: none;
}

.big-border {
    padding: 5px 40px 20px;
}
</style>
